import HttpClient from '@/utils/HttpClient';
import projectStore from '@/store/Projects';
export default {
  getComment(sourceType, allocationId) {
    return HttpClient.getAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/allocations/${sourceType}/${allocationId}/comment`
    );
  },
  updateComment(sourceType, allocationId, comment) {
    return HttpClient.updateAuthenticated(
      `/api/projects/${projectStore.activeProject.DbId}/allocations/${sourceType}/${allocationId}/comment`,
      {
        comment
      }
    );
  }
};
